/* Infos */

import "./services/search";
import { JobOverviewPage } from "./services/jobOverviewPage";
import { Splide } from "@splidejs/splide";
import { SearchBox } from "./services/searchbox";
import "./includes/mobileFilter";
import "./services/map";
import "./includes/jobSlider";
import "./includes/jobBanner";

declare global {
  interface Window {
    BorlabsCookie: {
      Consents: {
        hasConsent: (service: string) => boolean;
      };
    };
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector("body")?.classList.contains("page-template-job-overview-template")) {
    const jobOverviewPage = new JobOverviewPage();

    borlabsEventListener(jobOverviewPage);
  }

  new SearchBox();
  handleSearchResetButton();

  function borlabsEventListener(jobOverviewPage: JobOverviewPage) {
    // 1. Check whether Borlabs Cookie is loaded and active
    if (window.BorlabsCookie && window.BorlabsCookie.Consents) {
      // console.log("✅ Borlabs Cookie ist aktiv.");
      if (window.BorlabsCookie.Consents.hasConsent("maps")) {
        // console.log('"✅ Borlabs Cookie: Zustimmung für Google Maps vorhanden. Initialisiere Map."');
        jobOverviewPage.initializeMap();
      }
    } else {
      // console.log("❌ Borlabs Cookie ist nicht geladen oder nicht aktiv. Initialisiere Map.");
      jobOverviewPage.initializeMap();
    }

    // 2. Listen for the Borlabs Cookie consent event and unlock the map if consent is given
    window.addEventListener("borlabs-cookie-consent-saved", function () {
      // console.log("Borlabs Cookie Consent saved event triggered.");
      if (window.BorlabsCookie.Consents.hasConsent("maps")) {
        // console.log("borlabs google-maps consent saved, so initialize map");
        jobOverviewPage.initializeMap();
      }
    });

    document.addEventListener("click", function (e) {
      // console.log("Click erkannt.");
      if (e.target && (e.target as HTMLElement).classList.contains("brlbs-cmpnt-cb-btn")) {
        // Überprüfen, ob die Zustimmung für den spezifischen Dienst vorliegt
        setTimeout(() => {
          // console.log("Timer abgelaufen.");
          // if (window.BorlabsCookie.Consents.hasConsent("google-maps")) {
          //   console.log("borlabs google-maps consent saved, so initialize map");
          //   // jobOverviewPage.initializeMap();
          // } else {
          //   console.log("Borlabs Cookie: Keine Zustimmung für Google Maps.");
          // }
          let mapContainer = document.getElementById("maps") as HTMLElement;
          if (mapContainer) {
            jobOverviewPage.initializeMap();
            // console.log("Map initialized.");
          }
          // CHECK IF MAP DOM exists
        }, 500);
      }
    });
  }

  // horizontal slider
  const sliderElement = document.querySelector(".job-benefits-section-slider");

  if (sliderElement) {
    const slides = sliderElement.querySelectorAll(".splide__slide");
    const slideCount = slides.length;

    let defaultPerPage = 4;

    // Dynamisch anpassen
    if (slideCount < defaultPerPage) {
      defaultPerPage = slideCount;
    }

    // 👉 Klasse hinzufügen, wenn nicht genügend Slides vorhanden sind
    if (slideCount <= defaultPerPage) {
      sliderElement.classList.add("no-slider-needed");
    }

    new Splide(".job-benefits-section-slider", {
      type: "slide",
      perPage: defaultPerPage,
      perMove: 1,
      gap: "20px",
      arrows: true,
      pagination: false,
      dragMinThreshold: {
        mouse: 100, // Anzahl Pixel für Maus-Swipe
        touch: 60, // Anzahl Pixel für Touch-Swipe
      },
      breakpoints: {
        450: {
          perPage: Math.min(2, slideCount),
          focus: "center",
        },
        768: {
          perPage: Math.min(2, slideCount),
          focus: "center",
        },
        1070: {
          perPage: Math.min(3, slideCount),
        },
      },
    }).mount();
  }

  /**
   * Handles the fullscreen map overlay open/close logic.
   */
  function initFullscreenOverlayEvents() {
    const openBtn = document.querySelector(".map-overlay-button");
    const closeBtn = document.querySelector(".map-overlay-close");
    const overlay = document.getElementById("fullscreenMapOverlay");
    const body = document.querySelector("body");
    const header = document.querySelector(".elementor-location-header");

    openBtn?.addEventListener("click", () => {
      if (overlay) overlay.style.display = "block";
      window.scrollTo(0, 0);
      if (body) body.style.overflow = "hidden";
      header?.classList.add("map-is-open");
    });

    closeBtn?.addEventListener("click", () => {
      // if (this.overlay?.classList.contains("active")) {
      //   this.overlay.classList.remove("active");
      //   return;
      // }

      if (overlay) overlay.style.display = "none";
      if (body) body.style.overflow = "auto";
      header?.classList.remove("map-is-open");
    });
  }
  initFullscreenOverlayEvents();
});

// Wait on Images & CSS, Fonts etc.
window.addEventListener("load", () => {});

/* Helper Functions */

export function debounce<T extends (...args: any[]) => void>(
  func: T,
  wait: number,
  immediate: boolean = false
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  return (...args: Parameters<T>) => {
    // ✅ Kein `this`, kein Stress
    if (timeout) clearTimeout(timeout);

    const later = () => {
      timeout = null;
      if (!immediate) func(...args);
    };

    const callNow = immediate && !timeout;

    timeout = setTimeout(later, wait);

    if (callNow) func(...args);
  };
}

/** Like Debounce but executes the function immediately */
export function throttle<T extends (...args: any[]) => void>(func: T, limit: number): (...args: Parameters<T>) => void {
  let lastFunc: ReturnType<typeof setTimeout> | null = null;
  let lastRan: number | null = null;

  return function (this: unknown, ...args: Parameters<T>) {
    const context = this;

    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      if (lastFunc) clearTimeout(lastFunc);

      lastFunc = setTimeout(() => {
        if (lastRan && Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - (lastRan ?? 0)));
    }
  };
}

/**
 * Responsible for resetting search input fields when the reset button (X) is clicked.s
 */
function searchResetButton(resetButtons: NodeListOf<HTMLButtonElement>) {
  resetButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const target = e.currentTarget as HTMLButtonElement;

      const input =
        (target.previousElementSibling as HTMLInputElement) || (target.nextElementSibling as HTMLInputElement);

      if (input) {
        input.value = "";

        // trigger a change event to notify any listeners
        const event = new Event("input", { bubbles: true });
        input.dispatchEvent(event);
      }
    });
  });
}

/**
 * Handles the search reset button functionality.
 */
function handleSearchResetButton() {
  const resetButtons = document.querySelectorAll(".search-reset-button") as NodeListOf<HTMLButtonElement>;
  const searchInputs = document.querySelectorAll(".dt-search-form input") as NodeListOf<HTMLInputElement>;

  searchResetButton(resetButtons);
  handleResetVisibility(searchInputs);
}

function handleResetVisibility(searchInputs: NodeListOf<HTMLInputElement>) {
  searchInputs.forEach((input) => {
    setTimeout(() => toggleResetButtonVisibility(input), 100); // intital check for paramter reset button visibility
    input.addEventListener("input", () => toggleResetButtonVisibility(input));
  });
}

/**
 * Handles the visibility of the reset button based on input changes.
 * Shows the reset button only when the input field has a value.
 *
 * @param searchInputs
 */
function toggleResetButtonVisibility(input: HTMLInputElement) {
  const resetButton =
    (input.previousElementSibling as HTMLButtonElement) || (input.nextElementSibling as HTMLButtonElement);

  if (resetButton) {
    if (input.value.length > 0) {
      resetButton.classList.add("visible");
    } else {
      resetButton.classList.remove("visible");
    }
  }
}
